import styled from "styled-components";

export const StyledUploadErrorMessages = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 8px;
    font-size: var(--size-12);
    color: var(--color-error);
`;
